  // Check avoid include duplicate library Facebook SDK
  if($("#facebook-jssdk").length == 0) {
    (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = "//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.0";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  }

//responsive page cart

function cartResponsive(){
  var wrapperCart =  $('.wrapper__cartpage .cart__row');
  wrapperCart.each(function(){
    var $this = $(this); 
    $this.find('.js-edit-toggle ').click(function(){

      $(this).closest('.cart__price-wrapper').next().slideToggle('slow');
    });
  });
}

$(document).ready(function(){
	cartResponsive();
});